import { Amplify } from '@aws-amplify/core';

import LocalStorage from '../helpers/services/LocalStorage';

export default class Aws {
  static configureAmplify() {
    Amplify.configure({
      Auth: {
        identityPoolId: 'us-west-2:479d5c88-369e-4ebc-8782-f0acc6463491',
        region: 'us-west-2',
        userPoolId: 'us-west-2_fD8ohKI0Z',
        userPoolWebClientId: import.meta.env.VITE_COGNITO_CLIENT_ID,
        storage: LocalStorage.getInstance(),
      },
    });
  }
}
